import React, { Fragment, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../../App";
import { BackOfficeContext } from "../BackOffice";
import LoadedRecords from "../../../components/LoadedRecords";
import { Button, Col, Container, Dropdown, DropdownButton, Row, Table } from "react-bootstrap";
import Search from "../../../components/inputs/Search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faCircleNotch, faEllipsisV, faPlus, faTags } from "@fortawesome/free-solid-svg-icons";
import { postMethod } from "../../../requests";
import { faCalendarCheck, faCreditCard, faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import DiscountCodeUsageModal from "../../../components/modals/DiscountCodeUsageModal";
import moment from "moment";
import ManageDiscountCodeVisibilityActivityModal from "../../../components/modals/ManageDiscountCodeVisibilityActivityModal";

const DiscountCodesList = () => {
    const { t } = useTranslation();
    const { checkServerData, NOR, changeView } = useContext(BasicContext);
    const { discoutCodesList, setDiscoutCodesList } = useContext(BackOfficeContext);
    const [list, setList] = useState(discoutCodesList);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");
    const [displayNOR, setDisplayNOR] = useState(NOR);
    const [showDiscountCodeUsageModal, setShowDiscountCodeUsageModal] = useState(false);
    const [showManageDiscountCodeVisibilityActivityModal, setShowManageDiscountCodeVisibilityActivityModal] = useState(false);

    const handleSearch = (v) => {
        const searchedPhrase = v.toLowerCase();
        setSearch(searchedPhrase);
        if (searchedPhrase !== "") {
            let filterThisList = discoutCodesList;
            filterThisList = filterThisList.filter((el) => el.discount_code_name.toString().toLowerCase().includes(searchedPhrase));
            setList(filterThisList);
        } else {
            setList(discoutCodesList);
        }
    };

    useEffect(() => {
        if (list) setLoading(false);
        // eslint-disable-next-line
    }, [list]);

    const getDiscountCodes = async () => {
        const res = await postMethod("/get-discount-codes");
        if (checkServerData(res)) {
            setList(res.data.list);
            setDiscoutCodesList(res.data.list);
        }
    };

    useEffect(() => {
        if (!discoutCodesList) getDiscountCodes();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            {loading ? (
                <Container>
                    <Row>
                        <Col className="my-5 text-center">
                            <p className="h4">{t("loadingData")}</p>
                        </Col>
                    </Row>
                </Container>
            ) : (
                <Fragment>
                    <Container fluid="lg">
                        <Row>
                            <Col xs={12} className="px-4 my-4 px-lg-2 ">
                                <h1 className="h4 d-inline-block m-0 pt-2">{t("codes.discountCodes")}</h1>

                                <Button
                                    className="float-end d-inline-block"
                                    variant="outline-primary"
                                    onClick={() => changeView({ nav: "codes", sub: "createCode", params: { codeID: null } })}
                                >
                                    <FontAwesomeIcon icon={faPlus} className="me-lg-2" />
                                    <span className="d-none d-lg-inline">{t("codes.createNewCode")}</span>
                                </Button>

                                <Button
                                    className="float-end d-inline-block me-2"
                                    variant="outline-secondary"
                                    onClick={() => {
                                        setLoading(true);
                                        getDiscountCodes();
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowsRotate} />
                                </Button>
                            </Col>
                        </Row>
                        <Row className="sticky-top bg-light-primary">
                            <Col xs={12} lg={6} className="px-4 my-lg-4 my-3 px-lg-2 ">
                                <Search value={search} onChange={(e) => handleSearch(e.target.value)} />
                            </Col>
                        </Row>
                        <Row>
                            {list.length > 0 ? (
                                <Fragment>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="px-0 px-lg-2 ">
                                        <Table className="white-table" size="sm" borderless>
                                            <tbody>
                                                {list
                                                    .map((e, i) => (
                                                        <Fragment key={i}>
                                                            <tr>
                                                                <td className="bold border-bottom-0 pb-0">{e.discount_code_name}</td>
                                                                <td className="text-end border-bottom-0 pb-0">
                                                                    {t("used")}:{" "}
                                                                    <span className="bold">
                                                                        {e.discount_code_usage.length}
                                                                        {e.discount_code_quantity && <>/{e.discount_code_quantity}</>}
                                                                    </span>
                                                                </td>

                                                                <td className="text-center" rowSpan={4}>
                                                                    <DropdownButton
                                                                        id="dropdownMoreOptions"
                                                                        variant="outline-secondary"
                                                                        className="d-inline-block"
                                                                        size="sm"
                                                                        title={<FontAwesomeIcon icon={faEllipsisV} />}
                                                                    >
                                                                        <Dropdown.Item as={Button} variant="link" onClick={() => setShowDiscountCodeUsageModal(e)}>
                                                                            <FontAwesomeIcon icon={faCreditCard} className="me-2" />
                                                                            {t("codes.seeCodesUsage")}
                                                                        </Dropdown.Item>

                                                                        <Dropdown.Item
                                                                            as={Button}
                                                                            variant="link"
                                                                            onClick={() => {
                                                                                setShowManageDiscountCodeVisibilityActivityModal(e);
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faEye} className="me-2" />
                                                                            {t("codes.managectivityAndVisibility")}
                                                                        </Dropdown.Item>
                                                                    </DropdownButton>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="border-bottom-0 pb-0">
                                                                    <FontAwesomeIcon icon={faCalendarCheck} className="me-1 me-lg-2" />
                                                                    {e.discount_code_start_date ? (
                                                                        <>
                                                                            {e.discount_code_end_date ? (
                                                                                <>
                                                                                    <span className="bold">
                                                                                        {moment(e.discount_code_start_date).format("DD.MM.YYYY")} -{" "}
                                                                                        {moment(e.discount_code_end_date).format("DD.MM.YYYY")}
                                                                                    </span>
                                                                                </>
                                                                            ) : (
                                                                                <>
                                                                                    {t("fromDate")}:{" "}
                                                                                    <span className="bold">{moment(e.discount_code_start_date).format("DD.MM.YYYY")}</span>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    ) : (
                                                                        <i>{t("codes.noDateValues")}</i>
                                                                    )}
                                                                </td>
                                                                <td className="text-end border-bottom-0 pb-0">
                                                                    {t("created")}: {moment(e.discount_code_create_date).format("DD.MM.YYYY")}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="border-bottom-0 pb-0">
                                                                    <FontAwesomeIcon icon={faTags} className="me-1 me-lg-2" />
                                                                    {e.discount_value ? (
                                                                        <>
                                                                            {e.discount_value} {t("currency")}
                                                                        </>
                                                                    ) : (
                                                                        <>{e.discount_rate} %</>
                                                                    )}
                                                                </td>
                                                                <td className="text-end border-bottom-0 pb-0">
                                                                    {t(`codes.${e.discount_multiple_usage === "Y" ? "multipleUsageCode" : "singleUsageCode"}`)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <FontAwesomeIcon icon={e.discount_code_visible === "Y" ? faEye : faEyeSlash} className="me-1 me-lg-2" />
                                                                    {t(e.discount_code_visible === "Y" ? "visible" : "invisible")}
                                                                </td>
                                                                <td className="text-end">
                                                                    <FontAwesomeIcon icon={faCircleNotch} className="me-1 me-lg-2" />
                                                                    {t(`${e.discount_code_active === "Y" ? "active" : "inactive"}`)}
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    ))
                                                    .slice(0, displayNOR)}
                                            </tbody>
                                        </Table>
                                    </Col>
                                    <LoadedRecords displayNOR={displayNOR} list={list} />
                                    <Col xs={12} className="text-center">
                                        {displayNOR >= list.length ? (
                                            <p className="opacity-4  mb-3">
                                                <span className="px-3">{t("thatsAll")}</span>
                                            </p>
                                        ) : (
                                            <Button onClick={() => setDisplayNOR(NOR + displayNOR)} variant="outline-primary" className="mb-3">
                                                {t("loadMore")}
                                            </Button>
                                        )}
                                    </Col>
                                </Fragment>
                            ) : (
                                <Col xs={12} className="text-center">
                                    <p className="fs-5 my-3">{t("notFound")}</p>
                                </Col>
                            )}
                        </Row>
                    </Container>
                </Fragment>
            )}

            {showDiscountCodeUsageModal && <DiscountCodeUsageModal code={showDiscountCodeUsageModal} onClose={() => setShowDiscountCodeUsageModal(false)} />}
            {showManageDiscountCodeVisibilityActivityModal && (
                <ManageDiscountCodeVisibilityActivityModal
                    data={showManageDiscountCodeVisibilityActivityModal}
                    onClose={() => setShowManageDiscountCodeVisibilityActivityModal(false)}
                    reloadData={() => {
                        setLoading(true);
                        setShowManageDiscountCodeVisibilityActivityModal(false);
                        setTimeout(() => {
                            getDiscountCodes();
                        }, 150);
                    }}
                />
            )}
        </Fragment>
    );
};

export default DiscountCodesList;
